// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VenueCard_venue-card__CovE3 {
  display: flex;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}
.VenueCard_venue-card__CovE3 div:empty {
  display: none;
}
.VenueCard_venue-card__top__g2NU\\+ {
  display: flex;
  align-items: center;
  gap: 20px;
  align-self: stretch;
}
.VenueCard_venue-card__body__lAs0\\+ {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
}
.VenueCard_venue-card__body--item__MbHH3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.VenueCard_venue-card__body--item--title__rIGGv {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.VenueCard_venue-card__body--item--value__Z7Js- {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  align-self: stretch;
  color: var(--grey-text);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.VenueCard_venue-card__body__left__-RRqg {
  display: flex;
  padding-right: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  flex: 1 0;
}
.VenueCard_venue-card__body__right__Tz5ub {
  max-width: 500px;
  width: 100%;
  padding-left: 16px;
  border-left: 1px solid var(--accent-color-medium);
}
.VenueCard_venue-card__bottom__R6Pdb {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
}
.VenueCard_venue-card__CovE3 .VenueCard_name__FTwJK {
  color: var(--explore-color);
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 100% */
  letter-spacing: 0.4px;
}
.VenueCard_venue-card__CovE3 .VenueCard_name--wrapper__BR4cB {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 1;
}
.VenueCard_venue-card__CovE3 .VenueCard_entity-actions__ISKe4 {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.VenueCard_venue-card__CovE3 .VenueCard_entity-actions__ISKe4 .MuiButton-root {
  box-sizing: border-box;
  min-width: 130px;
  min-height: 36px;
}
.VenueCard_venue-card__CovE3 .VenueCard_favorite-btn__o-fYp {
  display: none;
  text-transform: uppercase;
}
.VenueCard_venue-card__CovE3 .VenueCard_link__W8yDr {
  cursor: pointer;
}
.VenueCard_venue-card__CovE3 .VenueCard_link__W8yDr:hover {
  text-decoration: underline;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm:empty {
  display: none;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm .VenueCard_statistic__3GRdw {
  display: flex;
  align-items: center;
  flex: initial;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm .VenueCard_statistic__3GRdw svg {
  margin-right: 4px;
  width: 15px;
  height: 15px;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm .VenueCard_statistic__3GRdw svg path {
  stroke: var(--accent-color);
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm .VenueCard_statistic__3GRdw p {
  font-size: 13px;
}
.VenueCard_venue-card__CovE3 .VenueCard_statistics__5aXbm .VenueCard_statistic__3GRdw span {
  color: var(--accent-color);
}
.VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW {
  max-height: 76px;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW span {
  color: var(--grey-text);
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW .VenueCard_keywords--item__z7UOf {
  display: flex;
  padding: 6px 12px;
  align-items: center;
  border-radius: 20px;
  background: var(--accent-color-light);
  color: var(--text-1);
  text-align: center;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-shadow: none;
  text-transform: initial;
}
.VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW .VenueCard_keywords--item__z7UOf.VenueCard_clickable__D3\\+gH {
  background: var(--accent-color-light);
  color: var(--text-1);
}
.VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW .VenueCard_keywords--item__z7UOf.VenueCard_clickable__D3\\+gH:hover {
  background: var(--accent-color);
  color: var(--text-0);
}
.VenueCard_venue-card__CovE3 .VenueCard_bio__QTNfq {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  align-self: stretch;
  overflow: hidden;
  color: var(--grey-text);
  text-overflow: ellipsis;
  font-family: "Lora", "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media only screen and (max-width: 480px) {
  .VenueCard_venue-card__CovE3 .VenueCard_keywords__h6qwW span:first-child {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/VenueCard/VenueCard.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AACF;AAEI;EACE,aAAA;AAAN;AAIE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAKI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AAHN;AAKM;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKM;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAMI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;AAJN;AAOI;EACE,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iDAAA;AALN;AASE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAPJ;AAUE;EACE,2BAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,qBAAA;AARJ;AAUI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AAVJ;AAYI;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;AAVN;AAcE;EACE,aAAA;EACA,yBAAA;AAZJ;AAeE;EACE,eAAA;AAbJ;AAcI;EACE,0BAAA;AAZN;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAdJ;AAeI;EACE,aAAA;AAbN;AAeI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;AAbN;AAeM;EACE,iBAAA;EACA,WAAA;EACA,YAAA;AAbR;AAeQ;EACE,2BAAA;AAbV;AAiBM;EACE,eAAA;AAfR;AAkBM;EACE,0BAAA;AAhBR;AAoBE;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAlBN;AAsBM;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+DAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApBR;AAsBQ;EACE,qCAAA;EACA,oBAAA;AApBV;AAqBU;EACE,+BAAA;EACA,oBAAA;AAnBZ;AA0BE;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,+DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAxBJ;;AA4BA;EAKM;IACE,aAAA;EA7BN;AACF","sourcesContent":[".venue-card {\n  display: flex;\n  padding: 20px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n\n  div {\n    &:empty {\n      display: none;\n    }\n  }\n\n  &__top {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  &__body {\n    display: flex;\n    padding: 10px;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-self: stretch;\n\n    &--item {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: flex-start;\n      gap: 4px;\n      align-self: stretch;\n\n      &--title {\n        color: var(--grey-text);\n        font-size: 13px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n      &--value {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: 1;\n        overflow: hidden;\n        align-self: stretch;\n        color: var(--grey-text);\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n      }\n    }\n    &__left {\n      display: flex;\n      padding-right: 16px;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 24px;\n      flex: 1 0 0;\n    }\n\n    &__right {\n      max-width: 500px;\n      width: 100%;\n      padding-left: 16px;\n      border-left: 1px solid var(--accent-color-medium);\n    }\n  }\n\n  &__bottom {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 20px;\n    align-self: stretch;\n  }\n\n  .name {\n    color: var(--explore-color);\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 100% */\n    letter-spacing: 0.4px;\n\n    &--wrapper {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      flex: 1;\n    }\n  }\n\n  .entity-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n\n    :global(.MuiButton-root) {\n      box-sizing: border-box;\n      min-width: 130px;\n      min-height: 36px;\n    }\n  }\n\n  .favorite-btn {\n    display: none;\n    text-transform: uppercase;\n  }\n\n  .link {\n    cursor: pointer;\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .statistics {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 20px;\n    &:empty {\n      display: none;\n    }\n    .statistic {\n      display: flex;\n      align-items: center;\n      flex: initial;\n\n      svg {\n        margin-right: 4px;\n        width: 15px;\n        height: 15px;\n\n        path {\n          stroke: var(--accent-color);\n        }\n      }\n\n      p {\n        font-size: 13px;\n      }\n\n      span {\n        color: var(--accent-color);\n      }\n    }\n  }\n  .keywords {\n    max-height: 76px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n\n    span {\n      color: var(--grey-text);\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n    }\n\n    .keywords {\n      &--item {\n        display: flex;\n        padding: 6px 12px;\n        align-items: center;\n        border-radius: 20px;\n        background: var(--accent-color-light);\n        color: var(--text-1);\n        text-align: center;\n        font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n        font-size: 0.85rem;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        box-shadow: none;\n        text-transform: initial;\n\n        &.clickable {\n          background: var(--accent-color-light);\n          color: var(--text-1);\n          &:hover {\n            background: var(--accent-color);\n            color: var(--text-0);\n          }\n        }\n      }\n    }\n  }\n\n  .bio {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 4;\n    align-self: stretch;\n    overflow: hidden;\n    color: var(--grey-text);\n    text-overflow: ellipsis;\n    font-family: \"Lora\", \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .venue-card {\n    .keywords {\n      // max-height: 56px;\n\n      span:first-child {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"venue-card": `VenueCard_venue-card__CovE3`,
	"venue-card__top": `VenueCard_venue-card__top__g2NU+`,
	"venue-card__body": `VenueCard_venue-card__body__lAs0+`,
	"venue-card__body--item": `VenueCard_venue-card__body--item__MbHH3`,
	"venue-card__body--item--title": `VenueCard_venue-card__body--item--title__rIGGv`,
	"venue-card__body--item--value": `VenueCard_venue-card__body--item--value__Z7Js-`,
	"venue-card__body__left": `VenueCard_venue-card__body__left__-RRqg`,
	"venue-card__body__right": `VenueCard_venue-card__body__right__Tz5ub`,
	"venue-card__bottom": `VenueCard_venue-card__bottom__R6Pdb`,
	"name": `VenueCard_name__FTwJK`,
	"name--wrapper": `VenueCard_name--wrapper__BR4cB`,
	"entity-actions": `VenueCard_entity-actions__ISKe4`,
	"favorite-btn": `VenueCard_favorite-btn__o-fYp`,
	"link": `VenueCard_link__W8yDr`,
	"statistics": `VenueCard_statistics__5aXbm`,
	"statistic": `VenueCard_statistic__3GRdw`,
	"keywords": `VenueCard_keywords__h6qwW`,
	"keywords--item": `VenueCard_keywords--item__z7UOf`,
	"clickable": `VenueCard_clickable__D3+gH`,
	"bio": `VenueCard_bio__QTNfq`
};
export default ___CSS_LOADER_EXPORT___;
